import { removeDuplicates, setSnackbar } from "../domain/Invoice";
import {
  get_upload_config,
  upload_files_to_s3,
  get_config_errors,
} from "../domain/UploadInvoice";

/**
 * Puja els fitxers de forma nova
 * @param screenData - Les dades de la pantalla
 * @param featureRepository - Repositori de funcionalitats
 * @param alertFn - Funció d'alerta
 * @param auth - AWS Auth
 * @param createDocumentBatch - Funció per crear batch de documents
 * @param syncCommandDispatcher - El dispatcher de comandos sincronitzat
 * @param context - El context del component Vue (this) - necessari per a get_config_errors i get_upload_config
 */
export async function uploadFiles2(
  screenData: any,
  featureRepository: any,
  alertFn: (message: string) => void,
  auth: any,
  createDocumentBatch: (files: any, uploadConfig: any) => Promise<any>,
  syncCommandDispatcher: any,
  context: any
): Promise<void> {

  screenData.general_error_text = "";
  screenData.general_error_dialog = false;

  removeDuplicates(screenData, featureRepository, alertFn);

  let error = get_config_errors(context);

  if (error) {
    handleError(screenData, error);
    return;
  }

  screenData.uploading = true;
  screenData.uploading_percent = 0;

  let upload_config = get_upload_config(context);

  let uploadStep = "uploading_files";

  try {

    let files = await upload_files_to_s3(context, auth);

    let res = await createDocumentBatch(files, upload_config);

    let args = { batch_id: res.data.id };
    
    uploadStep = "dispatching_command";

    res = await syncCommandDispatcher.dispatch("process.invoice.batch", args);

    if (res && res.output && res.output.success === false) {
      handleError(screenData, "Error al procesar los documentos.");
      return;
    }

    handleSuccess(screenData);

  } catch (err: any) {

    console.error("Error durante la subida de archivos:", err);

    if (err.code === "RequestTimeTooSkewed") {
      handleError(
        screenData,
        "Tu reloj del sistema está desincronizado con el servidor. Ajusta la configuración de fecha y hora automática en tu sistema operativo."
      );
      return;
    }

    if (uploadStep === "uploading_files") {
      handleError(
        screenData,
        "Los documentos no se han subido. Compruebe su conexión"
      );
      return;
    } 
    
    if (uploadStep === "dispatching_command") {
      handleError(
        screenData,
        "Ha habido un error en la subida. Compruebe que los documentos se han subido"
      );
      return;
    }
  }
}

const handleError = (screenData: any, message: string): void => {
  screenData.general_error_text = message;
  screenData.general_error_dialog = true;
  screenData.uploading = false;
};

const handleSuccess = (screenData: any): void => {
  screenData.uploading_file = "";
  screenData.uploaded_files = {};
  screenData.files = null;
  screenData.uploading = false;
  screenData.uploading_percent = 100;
  setSnackbar(screenData, "success", "Fichero(s) subido(s) correctamente");
};
